var _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgReel = function SvgReel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 128 128",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Circle_Grid",
    "data-name": "Circle Grid"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    fill: "#f6c863",
    r: 64
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m32.327 23h63.345v82h-63.345z",
    fill: "#575b6d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.534 23h44.34v19.68h-44.34z",
    fill: "#eeefee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.534 90.24h42.632v14.76h-42.632z",
    fill: "#eeefee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.466 23h11.207v82h-11.207z",
    fill: "#575b6d"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#eeefee"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m43.534 47.186h40.923v38.549h-40.923z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.027 23h5.808v4.914h-5.808z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.027 32.636h5.808v4.914h-5.808z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.027 42.271h5.808v4.914h-5.808z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.027 51.907h5.808v4.914h-5.808z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.027 61.543h5.808v4.914h-5.808z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.027 71.179h5.808v4.914h-5.808z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.027 80.814h5.808v4.914h-5.808z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.027 90.45h5.808v4.914h-5.808z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.027 100.086h5.808v4.914h-5.808z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87.161 23h5.808v4.914h-5.808z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87.161 32.636h5.808v4.914h-5.808z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87.161 42.271h5.808v4.914h-5.808z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87.161 51.907h5.808v4.914h-5.808z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87.161 61.543h5.808v4.914h-5.808z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87.161 71.179h5.808v4.914h-5.808z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87.161 80.814h5.808v4.914h-5.808z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87.161 90.45h5.808v4.914h-5.808z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87.161 100.086h5.808v4.914h-5.808z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reel.974a5926.svg";
export { ForwardRef as ReactComponent };